<input type="text" class="form-control" placeholder="Enter here">